import React from "react";
import Direction from "views/logic/aggregationbuilder/Direction";
import { SortIcon } from "components/common";
const _tooltip = (attributeTitle, newDirection) => `Sort ${attributeTitle} ${newDirection.direction}`;
const _changeSort = (nextDirection, attribute, onSortChange, setLoadingState) => {
  setLoadingState(true);
  onSortChange(attribute, nextDirection).then(() => {
    setLoadingState(false);
  });
};
const DirectionStrategyAsc = {
  tooltip: (attributeTitle) => _tooltip(attributeTitle, Direction.Descending),
  handleSortChange: (changeSort) => changeSort(Direction.Descending, true)
};
const DirectionStrategyDesc = {
  tooltip: (attributeTitle) => _tooltip(attributeTitle, Direction.Ascending),
  handleSortChange: (changeSort) => changeSort(Direction.Ascending, true)
};
const DirectionStrategyNoSort = {
  tooltip: (attributeTitle) => _tooltip(attributeTitle, Direction.Ascending),
  handleSortChange: (changeSort) => changeSort(Direction.Ascending, true)
};
const directionStrategy = (activeDirection) => {
  switch (activeDirection == null ? void 0 : activeDirection.direction) {
    case Direction.Ascending.direction:
      return DirectionStrategyAsc;
    case Direction.Descending.direction:
      return DirectionStrategyDesc;
    default:
      return DirectionStrategyNoSort;
  }
};
const AttributeSortIcon = ({
  attribute,
  attributeTitle,
  onSortChange,
  setLoadingState,
  activeDirection,
  activeAttribute
}) => {
  const targetAttributeDirection = activeAttribute === attribute ? activeDirection : void 0;
  const { tooltip, handleSortChange } = directionStrategy(activeDirection);
  const changeSort = (nextDirection) => _changeSort(nextDirection, attribute, onSortChange, setLoadingState);
  const title = tooltip(attributeTitle);
  return /* @__PURE__ */ React.createElement(
    SortIcon,
    {
      onChange: () => handleSortChange(changeSort),
      activeDirection: targetAttributeDirection == null ? void 0 : targetAttributeDirection.direction,
      title
    }
  );
};
export default AttributeSortIcon;
